module.exports = __webpack_public_path__ + "static/media/car.e3daf367.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/elements/IdentifierDetails/car.svg
// module id = 2154
// module chunks = 0